import React from 'react';
import { capitalize } from 'lodash';

import { toPeriodChartData } from '../../chart/period/PeriodChartDataConverter';
import { emptyTableConfig, isEmptyConfig, makeTableConfig } from '../table';
import PercentComponent from './PercentComponent';

// TODO для сплитов нужно переделать конфиг и продумать как отображать.
const getEventsPeriodData = (events) => {
  const { rows: resultRows } = events.reduce(
    ({ rows, values, groups }, { series, isDate, id }, eventIndex) => {
      const seriesVar = series;
      let valuesVar = values;
      const rowsVar = rows;

      // если один из ивентов пустой то для него ставится заглушка.
      seriesVar[0] = seriesVar[0] ? seriesVar[0] : { data: [] };

      const { timeUnit } = events[eventIndex];
      const { aggregation } = events[eventIndex];

      if (isDate) {
        const seriesId = seriesVar[0].parentId;

        seriesVar[0].data.forEach(([, value, groupBy], index) => {
          groups.add(groupBy);
          valuesVar = eventIndex === 0 ? valuesVar.concat(value) : valuesVar;
          const prevValue = valuesVar[index] || 0;

          const type = `${capitalize(timeUnit)} ${index + 1}`;

          const differenceDateElement = (
            <PercentComponent
              prevValue={prevValue}
              value={eventIndex === 0 ? 0 : value}
              diff={eventIndex === 0 ? value : prevValue - value}
            />
          );

          rowsVar[index] = {
            ...(rowsVar[index] || {}),
            Type: type,
            [`${timeUnit}(${seriesId})`]: groupBy,
            [`${aggregation}(${seriesId})`]: value,
            [`Difference(${seriesId[0]} - ${seriesId}), (%)`]: differenceDateElement,
          };
        });
      } else {
        seriesVar[0].data.forEach(([, , groupBy]) => groups.add(groupBy));

        Array.from(groups).forEach((g, index) => {
          const [, value, groupBy] = seriesVar[0].data.find(
            ([, , groupByParam]) => g === groupByParam
          ) || [g, 0, g];

          valuesVar = eventIndex === 0 ? valuesVar.concat(value) : valuesVar;
          const prevValue = valuesVar[index] || 0;

          const differenceElement = (
            <PercentComponent
              prevValue={prevValue}
              value={eventIndex === 0 ? 0 : value}
              diff={eventIndex === 0 ? value : prevValue - value}
            />
          );

          if (value === 0) {
            rowsVar[index] = {
              ...(rowsVar[index] || {}),
              [`Difference(${id[0]} - ${id}), (%)`]: differenceElement,
            };
          } else {
            rowsVar[index] = {
              ...(rowsVar[index] || {}),
              [`${timeUnit}(${id})`]: groupBy,
              [`${aggregation}(${id})`]: value,
              [`Difference(${id[0]} - ${id}), (%)`]: differenceElement,
            };
          }
        });
      }

      return { rows: rowsVar, values: valuesVar, groups };
    },
    { rows: [], values: [], groups: new Set() }
  );

  const resultEvents = events.reduce(
    ({ columns, originalColumns }, { timeUnit, aggregation, id }) => {
      const newColumns = [`${timeUnit}(${id})`, `${aggregation}(${id})`];
      const newOriginalColumns = [timeUnit, aggregation];

      // если только основной период - пропускаем diff
      if (id.length > 1) {
        const diffColumn = `Difference(${id[0]} - ${id}), (%)`;

        newColumns.push(diffColumn);
        newOriginalColumns.push('Difference');
      }

      const updatedColumns = columns.concat(...newColumns);
      const updatedOriginalColumns = originalColumns.concat(...newOriginalColumns);

      const res = {
        columns: updatedColumns,
        originalColumns: updatedOriginalColumns,
      };

      return res;
    },
    {
      columns: events[0].isDate ? ['Type'] : [],
      originalColumns: events[0].isDate ? ['Type'] : [],
    }
  );

  const { columns: resultColumns, originalColumns: resultOriginalColumns } = resultEvents;

  const filteredResultRows = resultRows.filter((row) => {
    return !events.every((e) => row[`${e.aggregation}(${e.id})`] === 0);
  });

  return {
    rows: filteredResultRows,
    columns: resultColumns,
    originalColumns: resultOriginalColumns,
    isSplitEvent: false,
  };
};

const getPeriodTableConfig = (events, metainf, zoneId) => {
  // пустой конфиг только если все ивенты пустые
  if (events.every((e) => isEmptyConfig(e))) {
    return emptyTableConfig;
  }
  const convertedEvents = toPeriodChartData(events);
  const { columns, rows, isSplitEvent, originalColumns } = getEventsPeriodData(convertedEvents);

  return makeTableConfig(metainf, { rows, columns }, zoneId, isSplitEvent, originalColumns);
};

export default getPeriodTableConfig;
